<div *ngIf="!showThankYou">
  <div mat-dialog-title>
    <div class="page-title-icon">
      <span class="card-header-value dialogue-tittle">Analysis Request</span>
      <button mat-icon-button class="close-button" (click)="onClose()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
      <div class="subtitle">
        Is there an analysis you’d like to see in the future? This is an optional field where you can suggest
        other analyses you’d be interested in. Your feedback helps us understand what matters most to you and
        guides us in developing new features. Leave blank if you prefer
      </div>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline" class="full-width text-box">
      <textarea
        matInput
        placeholder="Suggest an analysis you'd be interested in...[max 200words]"
        [(ngModel)]="analysisRequest"
        maxlength="200"
        cdkTextareaAutosize
      ></textarea>
    </mat-form-field>

    <!-- <div class="custom_checkbox">
      <mat-checkbox [(ngModel)]="isAdditionalAnalysisReqConsent" class="consent-checkbox-wrapper">
        <span class="consent-text">
          I would like StoreGene to contact me regarding any new analyses that become available in the future.
        </span>
      </mat-checkbox>
    </div> -->
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button  (click)="onBack()">
      Back
    </button>
    <button mat-flat-button color="primary"  (click)="onSubmit()">
      Submit
    </button>
  </mat-dialog-actions>
</div>

<div *ngIf="showThankYou" class="thank-you-container">
  <h1 class="thank-you-title">Thank you!</h1>
  
  <div class="thank-you-message">
    Your analysis request has been received and logged successfully. 
    Once your reports are ready, they will appear in the 
    <strong>My Reports</strong> page, which you can access anytime 
    from the side menu
  </div>

  <button mat-flat-button color="primary" class="close-button" (click)="onClose()">
    Close
  </button>
</div>